import { Link } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

interface ModuleNotActivatedProps {
  moduleCode: string;
  moduleName?: string;
}

/**
 * Shown when a user hits an escrow-module route that their organisation has not activated.
 */
export function ModuleNotActivated({ moduleCode, moduleName }: ModuleNotActivatedProps) {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto py-16 px-4">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <ShieldAlert className="h-6 w-6 text-amber-600" />
              <div>
                <CardTitle>Module not activated</CardTitle>
                <CardDescription>
                  {moduleName ?? moduleCode} is an escrow-licensed module and is not enabled for your organisation.
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-3 text-sm">
            <p>
              Escrow modules are activated by a platform administrator after the perpetual licence is countersigned by
              your organisation. Individual users must then be added to the module allowlist.
            </p>
            <p className="text-muted-foreground">
              Module code: <code className="font-mono">{moduleCode}</code>
            </p>
            <div className="flex gap-2 pt-2">
              <Button asChild variant="default">
                <Link to="/">Back to dashboard</Link>
              </Button>
              <Button asChild variant="outline">
                <a href={`mailto:support@pharmatrialconnect.com?subject=Activate ${moduleCode}`}>
                  Request activation
                </a>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
